/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Connection_Permissions_InvalidInputs */

const en_error_connection_permissions_invalid = /** @type {(inputs: Error_Connection_Permissions_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The connection asks for more than you may give it.`)
};

/**
* | output |
* | --- |
* | "The connection asks for more than you may give it." |
*
* @param {Error_Connection_Permissions_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_connection_permissions_invalid = /** @type {((inputs?: Error_Connection_Permissions_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Connection_Permissions_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_connection_permissions_invalid(inputs)
});